
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 1800 900"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('g',{attrs:{"id":"b"}},[_c('g',{attrs:{"id":"a"}},[_c('path',{attrs:{"d":"M1 0H0v.5z","transform":"translate(0 -.325)"}}),_c('path',{attrs:{"d":"M1 0H0v-.5z","transform":"rotate(-36 .5 -.162)"}})]),_c('use',{attrs:{"xlink:href":"#a","transform":"rotate(72)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"rotate(144)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"rotate(216)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"rotate(288)"}})])]),_c('path',{attrs:{"fill":"#00247d","d":"M0 0h1800v900H0z"}}),_c('g',{attrs:{"fill":"#fed100"}},[_c('path',{attrs:{"d":"M329.376 777.265c-17.934-.15 168.624-99.431 324.77-226.6C858.788 384 1299.54 117.157 1429.115 73.796c13.543-4.532-27.776 23.073-33.14 32.016-138.341 163.74-27.925 472.724 144.973 628.048 51.99 39.763 49.327 41.85 145.707 45.746v9l-1357.28-11.34zM318.125 795.325S304.962 804.727 305 811.73c.043 7.772 14.766 18.047 14.766 18.047l1338.745 14.765 24.609-16.406-34.453-21.328-1330.542-11.484z"}})]),_c('g',{attrs:{"fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#b","transform":"matrix(45 0 0 45 342.957 112.581)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"matrix(37.5 0 0 37.5 521.205 267.53)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"matrix(45 0 0 45 135 321.808)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"matrix(52.5 0 0 52.5 342.957 652.581)"}})])])
          )
        }
      }
    